module.exports = __webpack_public_path__ + "img/content7-12.5f40b3dc.webp";